import { render, staticRenderFns } from "./ManageVessels.vue?vue&type=template&id=6036775d&scoped=true&"
import script from "./ManageVessels.vue?vue&type=script&lang=ts&"
export * from "./ManageVessels.vue?vue&type=script&lang=ts&"
import style0 from "./ManageVessels.vue?vue&type=style&index=0&id=6036775d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6036775d",
  null
  
)

export default component.exports